import { createSlice } from '@reduxjs/toolkit'

export const bussinesSlice = createSlice({
    name: 'bussines',
    initialState: {
        name: { value: "", error: true },
        pointsOfSale: { value: "1", error: true },
        type: { value: "", error: true },
        paymentType: null,
        currency: { value: "", error: true },
        storeId: null
    },
    reducers: {
        setName: (state, action) => { state.name = action.payload },
        setType: (state, action) => { state.type = action.payload },
        setPaymentType: (state, action) => { state.paymentType = action.payload },
        setPointsOfSale: (state, action) => { state.pointsOfSale = action.payload },
        setCurrency: (state, action) => { state.currency = action.payload },
        setStoreId: (state, action) => { state.storeId = action.payload },
    },
})

// Action creators are generated for each case reducer function
export const { setName, setPointsOfSale, setType, setPaymentType, setCurrency, setStoreId } = bussinesSlice.actions
export default bussinesSlice.reducer